// extracted by mini-css-extract-plugin
export var container = "LoadingTile-module--container--294b8";